import { combineReducers } from 'redux';
import authentication from './authentication';

const createRootReducer = () =>
    combineReducers({
        authentication
    });
export default createRootReducer;